import { H3, H4, LI, P, UL } from "../../AbstractElements";
import { Link } from "react-router-dom";
import { CheckAll } from "../../Constant";
import { MESSAGE } from "../../Data/Header/Message";

export const Meassage = () => {
  return (
    <div className="onhover-show-div">
      <H3 className="f-18 mb-0 dropdown-title">Message</H3>
      <UL className="message-box">
        {MESSAGE.map((item, index) => (
          <LI key={index}>
            <div className="d-flex">
              <div className={`flex-shrink-0 bg-${item.bgColor}`}>{item.icon}</div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/chat/chat`}>
                  <H4>{item.title}</H4>
                  <P>{item.para}</P>
                </Link>
              </div>
              <span>{item.time}</span>
            </div>
          </LI>
        ))}
        <LI className="mt-3 check-button">
          <Link className="f-w-500" to={`${process.env.PUBLIC_URL}/email/email-app`}>
            {CheckAll}
          </Link>
        </LI>
      </UL>
    </div>
  );
};
